window.AmericanExpress = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            classNames: {
                disabledButton: 'vds-button--disabled',
                contentOpening: 'content-opening',
                hiddenItem: 'vds-item-hidden'
            },
            checkboxes: {
                checkboxGuards: '.checkbox-guard',
                uncheckedGuards: '.checkbox-guard:not(:checked)'
            },
            buttons: {
                guardedButtons: '.guarded-button',
                switchButtons: '.vds-content-switcher__switch-button',
                openOtherBenefitsModalLink: '#american-express-open-other-benefits-modal-link',
                stepOneNextButton: '#american-express-step-one-next-button',
                stepTwoNextButton: '#american-express-step-two-next-button',
                signupApplyButton: '#amex-signup-apply',
                copyMembershipLink: '#amex-membership-copy'
            },
            modals: {
                otherBenefitsModal: 'american-express-other-benefits-modal'
            }
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.switchContentById('booster-rates-content-opening');
            },
            bindings: function () {
                $(self.elements.checkboxes.checkboxGuards).change(self.func.checkGuards);
                $(self.elements.buttons.guardedButtons).click(self.func.blockDisabledButtonClicks);
                $(self.elements.buttons.switchButtons).click(self.func.switchContent);
                $(self.elements.buttons.openOtherBenefitsModalLink).click(self.func.openOtherBenefitsModal);
                $(self.elements.buttons.signupApplyButton).click(self.func.handleSignupApplyClick);
                $(self.elements.buttons.copyMembershipLink).click(self.func.handleCopyMembershipClick);
                $(self.elements.buttons.stepOneNextButton).click(self.func.handleStepOneNextButtonClick);
                $(self.elements.buttons.stepTwoNextButton).click(self.func.handleStepTwoNextButtonClick);
            },
            checkGuards: function () {
                const uncheckedBoxes = $(self.elements.checkboxes.uncheckedGuards);
                const allGuardsChecked = uncheckedBoxes.length === 0;
                $(self.elements.buttons.guardedButtons).each(function () {
                    if (allGuardsChecked) {
                        $(this).removeClass(self.elements.classNames.disabledButton);
                    } else {
                        $(this).addClass(self.elements.classNames.disabledButton);
                    }
                });
            },
            blockDisabledButtonClicks: function (event) {
                if ($(event.target).hasClass(self.elements.classNames.disabledButton)) {
                    event.preventDefault();
                }
            },
            switchContent: function (event) {
                const filter = $(event.target).data('filter');
                const contentOpeningId = filter + '-' + self.elements.classNames.contentOpening;
                self.func.switchContentById(contentOpeningId);
            },
            switchContentById: function (contentId) {
                const contentOpeningSelector = '.' + self.elements.classNames.contentOpening;
                const activeContentSelector = '#' + contentId;
                $(contentOpeningSelector).addClass(self.elements.classNames.hiddenItem);
                $(activeContentSelector).removeClass(self.elements.classNames.hiddenItem);
            },
            openOtherBenefitsModal: function (event) {
                if (event) {
                    event.preventDefault();
                }
                window.openModal(self.elements.modals.otherBenefitsModal);
                window.dataLayer.push(self.gtm.otherBenefitsModalOpenEvent);
            },
            handleSignupApplyClick: function () {
                window.dataLayer.push(self.gtm.applyNowButtonClickEvent);
            },
            handleCopyMembershipClick: function () {
                window.dataLayer.push(self.gtm.membershipNumberCopyEvent);
            },
            handleStepOneNextButtonClick: function () {
                window.dataLayer.push(self.gtm.formNextButtonClickEvent);
            },
            handleStepTwoNextButtonClick: function () {
                window.dataLayer.push(self.gtm.formApplyButtonClickEvent);
                window.dataLayer.push(self.gtm.amexSuccessfulRedirectEvent);
            }
        },
        gtm: {
            otherBenefitsModalOpenEvent: {
                event: 'formEvent',
                ctaClick: 'cardBenefits'
            },
            applyNowButtonClickEvent: {
                event: 'formContinue',
                section: 'review-details',
                ctaClick: 'apply'
            },
            membershipNumberCopyEvent: {
                event: 'formEvent',
                section: 'review-details',
                ctaClick: 'copyMembership'
            },
            formNextButtonClickEvent: {
                event: 'formContinue',
                section: 'confirmation'
            },
            formApplyButtonClickEvent: {
                event: 'formContinue',
                section: 'apply'
            },
            amexSuccessfulRedirectEvent: {
                event: 'formContinue',
                ctaClick: 'applyAtAmex'
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    const onAmexFormStepOnePage = $('#amex-form-step-one').length;
    const onAmexFormStepTwoPage = $('#amex-form-step-two').length;
    const onAmexFeaturePage = ($('#page-data').data('partner-name') === 'Amex');
    const onAmexPage = onAmexFormStepOnePage || onAmexFormStepTwoPage || onAmexFeaturePage;
    if(onAmexFeaturePage){
        const healthReviewToggle = ($('#page-data').data('feature-toggle') === 'True')
        if(healthReviewToggle) {
            $("#health-review-toggle-on").show();
            $("#health-review-toggle-off").hide();
        }
        else {
            $("#health-review-toggle-on").hide();
            $("#health-review-toggle-off").show();
        }
    }
    if (onAmexPage) {
        window.AmericanExpress.init();
    }
});
